(function() {
    'use strict';
    
    angular
    .module('szallodak-email-template', [
        'textAngular'
    ]);
})();
